import script from "./TableButton.vue?vue&type=script&setup=true&lang=js"
export * from "./TableButton.vue?vue&type=script&setup=true&lang=js"

import "./TableButton.vue?vue&type=style&index=0&id=404a1191&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-404a1191"]])

export default __exports__